<template>
  <div :style="{textAlign: align}">
    <picture class="hm-picture">
      <source type="image/webp" :srcset="localSrc">
      <img :class="imgClass" :src="localSrc" @click.self="showBigImage(localSrc)">
    </picture>
    <BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}"></BigImg>
  </div>
</template>

<script>
import BigImg from '../bigImg/bigImg.vue'

export default {
  name: 'hmImg',
  props: {
    // 类型, 访问路径
    type: { // images, icons
      type: String,
      default: 'images'
    },
    imgName: {
      type: String,
      default: ''
    },
    imgClass: {
      type: String,
      default: ''
    },
    big: {
      type: Boolean,
      default: false
    },
    srcBigImage: {
      type: String
    },
    align: {
      type: String,
      default: 'left'
    }
  },
  components: {
    BigImg
  },
  data () {
    return {
      cosUrl: 'https://hm-taxsaas-web-1304584340.cos.ap-guangzhou.myqcloud.com/tax-test/',
      imgHost: '',
      photoVisible: false,
      bigImgUrl: ''
    }
  },
  computed: {
    localSrc ({ type, imgName }) {
      return require(`@/assets/${type}/${imgName}.png`)
    },
    webpSrc ({ type, imgName }) {
      return require(`@/assets/${type}/${imgName}.webp`)
    },
    imgSrc ({ cosUrl, imgName }) {
      return `${cosUrl}${imgName}`
    },
    bigSrcImg ({ type, srcBigImage }) {
      return require(`@/assets/${type}/${srcBigImage}.png`)
    }
  },
  methods: {
    // 点击图片函数，点击后，把photoVisible设置成true
    showBigImage (e) {
      if (this.big) {
        this.photoVisible = true
        this.bigImgUrl = this.bigSrcImg
      }
    }
  }
}
</script>

<style>
.hm-picture {
  /* width: 100%; */
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/hm-img/index.vue